module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_midnight.70741c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_midnight.png
// module id = 2113
// module chunks = 0